import {
  is, prop, equals, assoc, curryN,
} from 'ramda';
/**
 * Util to get a value from an object using object nested keys
 * @param {String} key
 * @param {Object} obj
 * @returns
 */
// TODO: Replace with Ramda fn
export const path = (key, obj) => {
  const keys = key.split('.');
  return keys.reduce((acc, currKey) => (typeof acc === 'object' && acc !== null ? acc[currKey] : undefined), obj);
};

/**
 * Same path util with fallback value
 *
 * @param {*} fallback
 * @param {String} key
 * @param {Object} obj
 * @returns
 */
export const pathOr = (fallback, key, obj) => path(key, obj) || fallback;

/**
 * Differences between two object, it's similar to Ramda differences but
 * destinated to objects
 *
 * @param {Object} a
 * @param {Object} b
 * @returns Object
 */
export const differencesObj = curryN(2, (a, b) => Object.keys(a).reduce((acc, currKey) => {
  const aValue = prop(currKey, a);
  const bValue = prop(currKey, b);
  if (is(Object, aValue) && !Array.isArray(aValue) && bValue) {
    const objDiff = differencesObj(aValue, bValue);
    return Object.keys(objDiff).length > 0 ? assoc(currKey, objDiff, acc) : acc;
  }

  return equals(aValue, bValue) ? acc : assoc(currKey, aValue, acc);
}, {}));
